module.exports = __webpack_public_path__ + "static/media/multi_footer.14f5680e.png";